import { isSafeExternalUrl } from '../../security/validateExternalUrl';

/** The only host Google's Weather API ever returns condition icons from. */
export const WEATHER_ICON_ALLOWED_HOSTS = ['maps.gstatic.com'];

/**
 * Validates a weather condition icon URL before it's ever used as an <img>
 * src. Mirrors buildMapUrl.ts's resolveMapUrl: a URL arriving in a Gemini
 * response is untrusted input regardless of what the backend already
 * fetched it from, so it's re-checked here at the actual point of DOM
 * injection rather than trusted just because it originated from our tool.
 */
export function resolveWeatherIconUrl(iconUrl: string | undefined): string | null {
  if (!iconUrl) return null;
  return isSafeExternalUrl(iconUrl, {
    allowedHosts: WEATHER_ICON_ALLOWED_HOSTS,
    requireHttps: true,
  })
    ? iconUrl
    : null;
}
